enum NotificationStatus {
  Open = 0,
  ActionRequired = 1,
  SignedOff = 2,
  Rejected = 3,
  InProgress = 4,
}

export default NotificationStatus;
